import React from 'react';
import './Plan.css'; // Import your CSS file

import { Button } from '../../components';

import { FaCheck } from 'react-icons/fa';



const Plan = ({ plan }) => {

  const { image, icons, title, subtitle, speed, price, features } = plan;

  return (
    <div className="plan-item">

      <img src={image} alt={title} /> {/* Plan Image */}

      <div className='plan-content'>

        <div className='top'></div>

        <div className='intro'>
          <div className='speed'>up to <span>{speed}</span> Mbps</div>
          <h5>{subtitle}</h5> {/* Plan Name */}
          <h3>{title}</h3> {/* Plan Type */}
          <div className="icon-container">
            {icons.map((icon, index) => (
              <div className='plan-icon' key={index}>{icon}</div>
            ))}
          </div>
        </div>

        <div className='content'>

          {/* List of Features */}
          <ul>
            {features.map((feature, index) => (
              <li key={index}><div className='icon'><FaCheck /></div> {feature}</li> 
            ))}
          </ul>

          <div className='price-box'>
            <div className="price">${price}</div> {/* Plan Price */}
            <p>/ month</p>
          </div>

          <Button link={"Order-Now"} title={"Get Started"} />

        </div>

      </div>
    </div>
  );
};

export default Plan;